import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { Search } from '../../shared/user.model';
import swal from 'sweetalert2';

@Component({
  selector: 'app-e-lottery',
  templateUrl: './e-lottery.component.html',
  styleUrls: ['./e-lottery.component.css']
})
export class ELotteryComponent implements OnInit {

  Obj_Id: any;
  AFD: any = {};
  u: any = {};
  PND: any = {};
  Projects: any;
  Qlottery: any = {};
  Notifications: any;
  data: any;
  title = "Update objection"
  title1 = "Eligible/InEligible Category List"
  ap: any;
  fileToUpload: File = null;
  UO_UploadimageUrl1: string = "assets/images/image-default.png";
  formInvalid: boolean = false;
  ApplicationList;
  showMod = false;
  formSubmitted: boolean;
  Verified: any;
  s: Search;
  isSearch: boolean;
  object: any;
  itemsPerPage: number = 10;
  currentPage: number = 1;
  totalItems: number;
  proj_id: any;
  Not_Id: any;
  notify: any;
  ApplDetails: any = [];
  EligibleApplDetails: any = [];
  PropertyDetails: any = [];
  ApplAllotDetails: any = [];
  AppId: any;
  PropId: any;
  appno: any;
  propno: any;
  Not_ID: any;
  Proj_ID: any;
  PropT_Id: any;
  CAT_Id: any;
  Elot_LotteryId: any;
  index: any;
  RES_Id: any;
  Cat: any;
  Prop: any;
  Res: any;
  RESPercentage: any;
  indexj: any;
  indexi: any;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetNotifications();
    this.getAllProjectDetailsForScrutiny()
  }

  GetNotifications() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getNotifications();
    this.data.subscribe(
      (response: any) => {
        this.Notifications = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  getAllProjectDetailsForScrutiny() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllProjectDetailsForScrutiny();
    this.data.subscribe(
      (response: any) => {
        this.Projects = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  //get notification list
  GetNotificationProjects(Notification_Id, S_ProjectID) {
    this.index = null;
    this.indexi = null;
    this.indexj = null;

    if (S_ProjectID != null) {
      this.proj_id = S_ProjectID;
      if (this.notify == null)
        this.notify = 2;
    }

    if (Notification_Id != null) {
      this.Not_Id = Notification_Id;
      if (this.notify == null)
        this.notify = 1;
    }

    if (this.notify == 1 && Notification_Id != null) {
      this.proj_id = null;
    }
    if (this.notify == 2 && S_ProjectID != null) {
      this.Not_Id = null;
    }

    if (Notification_Id == null && this.notify == 2) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getNotificationDetailsForScrutiny(S_ProjectID);
      this.data.subscribe(
        (response: any) => {
          this.Notifications = response;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          this.errorHandler.HandlerError(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }

    else if (S_ProjectID == null && this.notify == 1) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getProjectDetailsForScrutiny(Notification_Id);
      this.data.subscribe(
        (response: any) => {
          this.Projects = response;

          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          this.errorHandler.HandlerError(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }

  }

  
  GetApplicantDetailsforElottery(DSWOID_NO_Id, PD_Id) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetApplicantDetailsforElottery(DSWOID_NO_Id, PD_Id);
    this.data.subscribe(
      (response: any) => {
        this.ApplDetails = response;
        this.ApplAllotDetails = [];

        for (let j = 0; j < this.ApplDetails.length; j++) {
          if (j == this.indexi) {
            for (let k = 0; k < this.ApplDetails[j].ElotteryPropertyModel.length; k++) {
              if (k == this.indexj) {

                for (let i = 0; i < this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel.length; i++) {
                  if (i == this.index) {
                    this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel[i].visible = "Y";
                  } else {
                    this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel[i].visible = "N";
                  }
                }

              }
            }
          }
        }

        // for (let i = 0; i < this.ApplDetails.ElotteryPropertyModel.ElotteryModel.length; i++) {
        //   if (i == this.index) {
        //     this.ApplDetails.ElotteryModel[i].visible="Y";
        //   }else
        //   {
        //     this.ApplDetails.ElotteryModel[i].visible="N";
        //   }
        // }

        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        this.errorHandler.HandlerError(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  // GetApplicantDetailsforElottery(DSWOID_NO_Id, PD_Id) {
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetApplicantDetailsforElottery(DSWOID_NO_Id, PD_Id);
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.ApplDetails = response;
  //       this.ApplAllotDetails = [];
  //       for (let i = 0; i < this.ApplDetails.ElotteryModel.length; i++) {
  //         if (i == this.index) {
  //           this.ApplDetails.ElotteryModel[i].visible="Y";
  //         }else
  //         {
  //           this.ApplDetails.ElotteryModel[i].visible="N";
  //         }
  //       }
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       this.errorHandler.HandlerError(error);
  //       document.getElementById('loader-spinner').style.display = "none";
  //     });
  // }

  GetApplicantandPropertyDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id, RES_Id, indi, indj, ind) {//,Cat,Prop,Res
    
    this.Not_ID = lot_Not_ID
    this.Proj_ID = lot_Proj_ID
    this.PropT_Id = PT_Id
    this.CAT_Id = CA_Id
    this.RES_Id = RES_Id

    for (let j = 0; j < this.ApplDetails.length; j++) {
      if (j == indi) {
        for (let k = 0; k < this.ApplDetails[j].ElotteryPropertyModel.length; k++) {
          if (k == indj) {
            for (let i = 0; i < this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel.length; i++) {
              if (i == ind) {
                this.Cat = this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel[i].CA_CategoryName;
                this.Prop = this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel[i].PT_Property_Type;
                this.Res = this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel[i].RES_Name;
                this.RESPercentage = this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel[i].RES_Percentage;
              }
            }
          }
        }
      }
    }



    // for (let i = 0; i < this.ApplDetails.ElotteryModel.length; i++) {
    //   if (i == ind) {
    //     this.Cat = this.ApplDetails.ElotteryModel[i].CA_CategoryName;
    //     this.Prop = this.ApplDetails.ElotteryModel[i].PT_Property_Type;
    //     this.Res = this.ApplDetails.ElotteryModel[i].RES_Name;
    //     this.RESPercentage = this.ApplDetails.ElotteryModel[i].RES_Percentage;
    //   }
    // }
    this.indexi = indi;
    this.indexj = indj;
    this.index = ind;

    this.GetApplicantDetailsforElottery(lot_Not_ID, lot_Proj_ID)
    this.GetEligibleApplicantDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id, RES_Id)
    this.GetPropertyDetailsforElottery(lot_Proj_ID, PT_Id, CA_Id)


    for (let j = 0; j < this.ApplDetails.length; j++) {
      if (j == indi) {
        for (let k = 0; k < this.ApplDetails[j].ElotteryPropertyModel.length; k++) {
          if (k == indj) {

            for (let i = 0; i < this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel.length; i++) {
              if (i == ind) {
                this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel[i].visible = "Y";
              } else {
                this.ApplDetails[j].ElotteryPropertyModel[k].ElotteryModel[i].visible = "N";
              }
            }

          }
        }
      }
    }



    // for (let i = 0; i < this.ApplDetails.ElotteryModel.length; i++) {
    //   if (i == ind) {
    //     this.ApplDetails.ElotteryModel[i].visible = "Y";
    //   } else {
    //     this.ApplDetails.ElotteryModel[i].visible = "N";
    //   }
    // }
    // this.GetAllottedDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id)
  }

  GetEligibleApplicantDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id, RES_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetEligibleApplicantDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id, RES_Id);
    this.data.subscribe(
      (response: any) => {
        this.EligibleApplDetails = response;

        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  GetPropertyDetailsforElottery(lot_Proj_ID, PT_Id, CA_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetPropertyDetailsforElottery(lot_Proj_ID, PT_Id, CA_Id);
    this.data.subscribe(
      (response: any) => {
        this.PropertyDetails = response;

        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
  }

  // GetAllottedDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id) {
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetAllottedDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id);
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.ApplAllotDetails = response;

  //       document.getElementById('loader-spinner').style.display = "none";
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       this.errorHandler.HandlerError(error);
  //     });
  // }

  Elottery() {
    
    var app, prop, i, j;
    if (this.EligibleApplDetails.length != 0 && this.PropertyDetails.length != 0) {
      app = Math.floor(Math.random() * this.EligibleApplDetails.length) + 0;
      prop = Math.floor(Math.random() * this.PropertyDetails.length) + 0;
    }
    else {
      if (this.EligibleApplDetails.length == 0 || this.PropertyDetails.length == 0) {
        swal('', "No Applications or Properties to Allot!", 'warning');
        return;
      } else {
        swal('', "Allotted Successfully!", 'success');
      }
    }
    if (this.EligibleApplDetails.length != 0 && this.PropertyDetails.length != 0) {
      for (i = 0; i < this.EligibleApplDetails.length; i++) {
        if (i == app) {
          this.AppId = this.EligibleApplDetails[i].APP_Id;
          this.appno = this.EligibleApplDetails[i].APP_No;
        }
      }
      for (j = 0; j < this.PropertyDetails.length; j++) {
        if (j == prop) {
          this.PropId = this.PropertyDetails[j].PR_Id;
          this.propno = this.PropertyDetails[j].PR_Property_No;
        }
      }
    }
    // this.SaveElottery()
  }

  QElottery() {
    
    swal({
      title: 'Are you sure?', text: "You want to Allot!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Allot!'
    }).then((result) => {
      if (result.value) {
        this.QEAllotlottery();
      }
    })

  }

  QEAllotlottery() {
    let length, k;
    let applen = this.EligibleApplDetails.length
    let proplength = this.PropertyDetails.length
    if (applen < proplength) {
      length = applen;
    } else {
      length = proplength
    }
    if (this.EligibleApplDetails.length == 0 || this.PropertyDetails.length == 0) {
      swal('', "No Applications or Properties to Allot!", 'warning');
      return;
    }
    //else {
    //   swal('', "Allotted Successfully!", 'success');
    // }
    for (k = 0; k < length; k++) {
      this.QElotteryAllot()
    }
    this.appno = null;
    this.propno = null;
    swal('', "Elottery Allotment Processed Successfully!", 'success');
  }

  QElotteryAllot() {
    
    var app, prop, i, j, flag = 0;
    let EAD_PR_Id_Fk = null, EAD_APP_Id_Fk = null, APP_PA_Name = null, APP_No = null, PR_Property_No = null,
      CA_CategoryName = null, PT_Property_Type = null, PT_Id = null, CA_Id = null, RES_Name = null;

    if (this.EligibleApplDetails.length != 0 && this.PropertyDetails.length != 0) {
      app = Math.floor(Math.random() * this.EligibleApplDetails.length) + 0;
      prop = Math.floor(Math.random() * this.PropertyDetails.length) + 0;
    }
    else {
      if (this.ApplDetails.length == 0) {
        swal('', "No Applications or Properties to Allot!", 'warning');
      } else {
        swal('', "Elottery Allotment Processed Successfully!", 'success');
      }
    }
    if (this.EligibleApplDetails.length != 0 && this.PropertyDetails.length != 0) {
      for (i = 0; i < this.EligibleApplDetails.length; i++) {
        if (i == app) {
          this.AppId = this.EligibleApplDetails[i].APP_Id;
          this.appno = this.EligibleApplDetails[i].APP_No;
          EAD_APP_Id_Fk = this.EligibleApplDetails[i].APP_Id;
          APP_PA_Name = this.EligibleApplDetails[i].APP_PA_Name;
          APP_No = this.EligibleApplDetails[i].APP_No;
          RES_Name = this.EligibleApplDetails[i].RES_Name;
          this.EligibleApplDetails.splice(i, 1);
        }
      }

      for (j = 0; j < this.PropertyDetails.length; j++) {
        if (j == prop) {
          this.PropId = this.PropertyDetails[j].PR_Id;
          this.propno = this.PropertyDetails[j].PR_Property_No;
          EAD_PR_Id_Fk = this.PropertyDetails[j].PR_Id;
          PR_Property_No = this.PropertyDetails[j].PR_Property_No;
          CA_CategoryName = this.PropertyDetails[j].CA_CategoryName;
          PT_Property_Type = this.PropertyDetails[j].PT_Property_Type;
          PT_Id = this.PropertyDetails[j].PT_Id;
          CA_Id = this.PropertyDetails[j].CA_Id;
          this.PropertyDetails.splice(j, 1);
        }
      }

      // this.SaveElottery()
      let temp = {
        EAD_PR_Id_Fk: EAD_PR_Id_Fk,
        APP_PA_Name: APP_PA_Name,
        EAD_APP_Id_Fk: EAD_APP_Id_Fk,
        APP_No: APP_No,
        PR_Property_No: PR_Property_No,
        CA_CategoryName: CA_CategoryName,
        PT_Property_Type: PT_Property_Type,
        PT_Id: PT_Id,
        CA_Id: CA_Id,
        RES_Name: RES_Name
      }
      this.ApplAllotDetails.push(temp);
    }
  }

  // GetApplicantandPropertyDetailsforQElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id) {
  //   this.SaveElottery()
  //   this.GetEligibleApplicantDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id)
  //   this.GetPropertyDetailsforElottery(lot_Proj_ID, PT_Id, CA_Id)
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.GetAllottedDetailsforElottery(lot_Not_ID, lot_Proj_ID, PT_Id, CA_Id)
  // }

  FinalizeElottery() {
    
    swal({
      title: 'Are you sure?', text: "You want to Finalize!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, Finalize!'
    }).then((result) => {
      if (result.value) {
        this.SaveElottery();
      }
    })

  }
  SaveElottery() {
    
    this.Qlottery.Elot_Id = "Lot-" + this.ApplDetails.Elot_Id;
    this.Qlottery.Elot_Not_Id_Fk = this.Not_ID;
    this.Qlottery.Elot_Proj_Id_Fk = this.Proj_ID;
    this.Qlottery.Elot_PT_Id_Fk = this.PropT_Id;
    this.Qlottery.Elot_CA_Id_Fk = this.CAT_Id;
    this.Qlottery.ElotteryAllotmentModel = this.ApplAllotDetails;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.SaveElottery(this.Qlottery)
      .subscribe(
        (data) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.GetApplicantandPropertyDetailsforElottery(this.Not_ID, this.Proj_ID, this.PropT_Id, this.CAT_Id, this.RES_Id, this.indexi, this.indexj, this.index)
          this.ApplAllotDetails = [];
          swal('', "Elottery Allotment Finalized Successfully!", 'success');
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  Clear() {
    this.ApplAllotDetails = [];
    this.GetEligibleApplicantDetailsforElottery(this.Not_ID, this.Proj_ID, this.PropT_Id, this.CAT_Id, this.RES_Id)
    this.GetPropertyDetailsforElottery(this.Proj_ID, this.PropT_Id, this.CAT_Id)
  }
}



// WEBPACK FOOTER //
// ./src/app/allocation/e-lottery/e-lottery.component.ts